import Const from 'constants';

const defaultState = {
    data: {
        exposureMode: Const.EXPOSURE_MODE_OPTIMAL,
    },
    getExposureMode() {
        return this.data.exposureMode;
    },
    isModeTournament() {
        return this.getExposureMode() === Const.EXPOSURE_MODE_TOURNAMENT;
    },
};

export default function (state = defaultState, action) {
    if (action.type === Const.SET_EXPOSURE_MODE) {
        state = {...state};
        state.data.exposureMode = action.value;
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {
            ...defaultState,
            data: {
                exposureMode: Const.EXPOSURE_MODE_OPTIMAL,
            },
        };
    }

    return state;
}
